import { createSlice } from '@reduxjs/toolkit';

import type { PayloadAction } from '@reduxjs/toolkit';

interface OrdersState {
    orderId?: string;
}

const initialState = {
    orderId: undefined,
} satisfies OrdersState as OrdersState;

const ordersSlice = createSlice({
    initialState,
    name: 'orders',
    reducers: {
        orderIdReceived(state, action: PayloadAction<OrdersState>) {
            const {
                orderId,
            } = action.payload;

            state.orderId = orderId;
        },
    },
    selectors: {
        selectOrderId: (({
            orderId,
        }: OrdersState) => ({
            orderId,
        })),
    },
});

export type Orders =
    ReturnType<typeof ordersSlice.selectors.selectOrderId>;

export const { actions, selectors } = ordersSlice;
export const { orderIdReceived } = actions;
export default ordersSlice.reducer;
